import React, { useState } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { selectSort } from "../redux/filter/selectors";
import { setSort } from "../redux/filter/slice";
import { SortPropertyEnum } from "../redux/filter/types";

type ListTypes = {
    name: string;
    sortProperty: SortPropertyEnum;
};

type PopapClick = MouseEvent & {
    path: Node[];
}

export const list: ListTypes[] = [
    { name: 'популярністю ↓', sortProperty: SortPropertyEnum.RATING_DESC },
    { name: 'популярністю ↑', sortProperty: SortPropertyEnum.RATING_ASC },
    { name: 'ціною ↓', sortProperty: SortPropertyEnum.PRICE_DESC },
    { name: 'ціною ↑', sortProperty: SortPropertyEnum.PRICE_ASC },
    { name: 'алфавітом ↓', sortProperty: SortPropertyEnum.TITLE_DESC },
    { name: 'алфавітом ↑', sortProperty: SortPropertyEnum.TITLE_ASC },
]

export const SortPopup: React.FC = React.memo(() => {
    const dispatch = useDispatch();

    const sort = useSelector(selectSort)

    const sortRef = React.useRef<HTMLDivElement>(null);

    const [isVisible, setIsVisible] = useState(false);


    function onClickSortItems(obj: ListTypes) {
        dispatch(setSort(obj))
        setIsVisible(false)
    }

    //! useEffect буде викликатись постійно при рендері сторінки (наприклад зайшов в корзину і потом назад повернувся), із-за цього буде постійно створюватись новий обробник подій, щоб це уникнути, використовуємо return == unMount
    React.useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            const _event = event as PopapClick;
            if (sortRef.current && !_event.path.includes(sortRef.current)) {
                setIsVisible(false)
            }
        };
        document.body.addEventListener('click', handleClickOutside);

        //! Якщо компонент має зникнути із сторінки (unMount), то видаляємо обробник події 
        return () => document.body.removeEventListener('click', handleClickOutside);
    }, [])

    return (
        <div ref={sortRef} className="sort">
            <div className="sort__label">
                <svg
                    width="10"
                    height="6"
                    viewBox="0 0 10 6"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M10 5C10 5.16927 9.93815 5.31576 9.81445 5.43945C9.69075 5.56315 9.54427 5.625 9.375 5.625H0.625C0.455729 5.625 0.309245 5.56315 0.185547 5.43945C0.061849 5.31576 0 5.16927 0 5C0 4.83073 0.061849 4.68424 0.185547 4.56055L4.56055 0.185547C4.68424 0.061849 4.83073 0 5 0C5.16927 0 5.31576 0.061849 5.43945 0.185547L9.81445 4.56055C9.93815 4.68424 10 4.83073 10 5Z"
                        fill="#2C2C2C"
                    />
                </svg>
                <b>Сортування за:</b>
                <span onClick={() => setIsVisible(!isVisible)}>{sort.name}</span>
            </div>
            {
                isVisible && (
                    <div className="sort__popup">
                        <ul>
                            {
                                list.map((value, index) => {
                                    return (
                                        <li
                                            key={index.toString()}
                                            onClick={() => onClickSortItems(value)}
                                            className={sort.sortProperty === value.sortProperty ? 'active' : ''}>{value.name}</li>
                                    )
                                })
                            }
                        </ul>
                    </div>
                )
            }
        </div>
    )
})
